module.exports = __webpack_public_path__ + "server-side-application.jTEOcUJy.svg";